import type { Step_Up_Transformers } from "gql/api";
import type { EquipmentTableColumn } from "@/composables/equipment/equipmentTypes";

export const sutTableColumns: EquipmentTableColumn<Step_Up_Transformers>[] = [
  {
    editable: true,
    field: "include_koc_timestamp",
    header: "Include KOC",
    sortable: true,
    isCheckbox: true,
    adminOnly: true
  },
  {
    editable: true,
    field: "only_koc_timestamp",
    header: "KOC Only",
    sortable: true,
    isCheckbox: true,
    adminOnly: true
  },
  {
    editable: true,
    field: "include_ecopetrol_timestamp",
    header: "Include Ecopetrol",
    sortable: true,
    isCheckbox: true,
    adminOnly: true
  },
  {
    editable: true,
    field: "only_ecopetrol_timestamp",
    header: "Ecopetrol Only",
    sortable: true,
    isCheckbox: true,
    adminOnly: true
  },
  {
    editable: true,
    sortable: true,
    field: "manufacturer",
    header: "Manufacturer",
    searchable: true
  },
  {
    editable: true,
    sortable: true,
    field: "kva",
    header: "kVa",
    isNumber: true,
    searchable: true
  },
  {
    editable: true,
    sortable: true,
    field: "transformer_type",
    header: "Type",
    searchable: true
  },
  {
    editable: true,
    sortable: true,
    field: "enclosure",
    header: "Enclosure",
    searchable: true
  },
  {
    editable: true,
    sortable: true,
    field: "primary_voltage",
    header: "Primary",
    isNumber: true,
    searchable: true
  },
  {
    editable: true,
    sortable: true,
    field: "min_secondary_voltage",
    header: "Min Secondary Voltage",
    isNumber: true
  },
  {
    editable: true,
    sortable: true,
    field: "max_secondary_voltage",
    header: "Max Secondary Voltage",
    isNumber: true
  }
];
